import EditOutlined from '@ant-design/icons/lib/icons/EditOutlined'
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import moment from 'moment'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { baseAxiosComplete, baseAxiosNoInfo } from '../../../tool/axios'

const {Option} = Select

interface person {
    check_in_id:string
    belong_minion_id:  string//责任管家id
    belong_minion_name: string, // 责任管家名称
    belong_cleaner_id: string, // 生活助理（保洁）id
    belong_cleaner_name: string, // 生活助理（保洁）名称
    belong_nurse_id: string, // 责任护士id
    belong_nurse_name: string, // 责任护士名称，冗余字段
    belong_dietician_id: string, // 营养师id
    belong_dietician_name: string, // 营养师名称
    belong_recover_id: string, // 产康师id
    belong_recover_name: string, // 产康师名称
    belong_look_after_id: string, // 护理师id
    belong_look_after_name: string, // 护理师名称
}

const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 }
}

interface ep {
    "employee_id": string,
    "user_name": string
}

interface Prop{
    storeID?:string
    serviceData?:person
    onChange?: ()=>void
}
export default function (prop:Prop) {
    
    const param: { id: string } = useParams()
    const [visible, setVisible] = useState<boolean>(false)
    const [visible2, setVisible2] = useState<boolean>(false)
    const [form] = useForm()
    // const [ep26Data,setEp26Data] = useState<ep[]>([])
    // const [ep34Data,setEp34Data] = useState<ep[]>([])
    const [ep35Data,setEp35Data] = useState<ep[]>([])
    // const [ep36Data,setEp36Data] = useState<ep[]>([])
    // const [ep37Data,setEp37Data] = useState<ep[]>([])
    const [ep38Data,setEp38Data] = useState<ep[]>([])
    const [hasServiceEmployee,setHasServiceEmployee] = useState<number>(0)

    const changeFirstWaiter = (values: any) => {
        // 初次分配服务人员
        baseAxiosComplete.post('/nursing/customer/detail/distribute_service_employee', {
            check_in_id:param.id,
            // belong_minion_id: values.belong_minion_id ,//责任管家id
            // belong_cleaner_id: values.belong_cleaner_id, // 生活助理（保洁）id
            belong_nurse_id: values.belong_nurse_id, // 责任护士id
            // belong_dietician_id: values.belong_dietician_id, // 营养师id
            // belong_recover_id: values.belong_recover_id, // 产康师id
            belong_look_after_id: values.belong_look_after_id, // 护理师id
        }).then(res => {
            if (res.status === 0){
                setVisible(false)
                if(prop.onChange) prop.onChange()
            }
        })
    }

    useEffect(()=>{
        if(prop.storeID){
            // baseAxiosNoInfo('/global/employee_list_by_position',{params:{
            //     department_id: prop.storeID,
            //     position_number:'26,22'
            // }}).then((res:any)=>{
            //     res && setEp26Data(res)
            // })
            // baseAxiosNoInfo('/global/employee_list_by_position',{params:{
            //     department_id: prop.storeID,
            //     position_number:70
            // }}).then((res:any)=>{
            //     res && setEp34Data(res)
            // })
            baseAxiosNoInfo('/global/employee_list_by_position',{params:{
                department_id: prop.storeID,
                position_number:35
            }}).then((res:any)=>{
                res && setEp35Data(res)
            })
            // baseAxiosNoInfo('/global/employee_list_by_position',{params:{
            //     department_id: prop.storeID,
            //     position_number:36
            // }}).then((res:any)=>{
            //     res && setEp36Data(res)
            // })
            // baseAxiosNoInfo('/global/employee_list_by_position',{params:{
            //     department_id: prop.storeID,
            //     position_number:37
            // }}).then((res:any)=>{
            //     res && setEp37Data(res)
            // })
            baseAxiosNoInfo('/global/employee_list_by_position',{params:{
                department_id: prop.storeID,
                position_number:38
            }}).then((res:any)=>{
                res && setEp38Data(res)
            })
        }
    },[prop.storeID])

    useEffect(()=>{
        // 查询是否有分配过服务人员
        baseAxiosNoInfo('/nursing/customer/detail/has_service_employee',{params:{
            check_in_id:param.id
        }}).then((res:any)=>{// 0 || 1
            setHasServiceEmployee(res)
        })
    },[])

    return (<div className="modules">

        <Modal title="编辑服务人员信息" visible={visible} onCancel={() => { setVisible(false) }} footer={false}>
            <Form  {...formItemLayout} form={form} onFinish={changeFirstWaiter} >
                <Form.Item label="护士" name="belong_nurse_id" rules={[{ required: true, message: '必须选择护士' }]}>
                    <Select  virtual={false}>
                        {ep35Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="护理师" name="belong_look_after_id" >
                    <Select virtual={false}>
                        {ep38Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                {/* <Form.Item label="责任护士" name="belong_nurse_id" >
                    <Select virtual={false}>
                        {ep35Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="营养师" name="belong_dietician_id" >
                    <Select virtual={false}>
                        {ep36Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="产康师" name="belong_recover_id" >
                    <Select virtual={false}>
                        {ep37Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="护理师" name="belong_look_after_id" >
                    <Select virtual={false}>
                        {ep38Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item> */}
                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
            
        <Modal title="更换服务人员" visible={visible2} onCancel={() => { setVisible2(false) }} footer={false}>
            <Form  {...formItemLayout} form={form}>
                <Form.Item label="护士" name="belong_nurse_id" >
                    <Select  virtual={false}>
                        {ep35Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="新护理师" name="new_look_after_id" >
                    <Select virtual={false}>
                        {ep38Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="原护理师下单原因" name="advance_reason" >
                    <Input/>
                </Form.Item>
                <Form.Item label="原护理师下单时间" name="down_single_time" >
                    <DatePicker showTime  />
                </Form.Item>
                
                {/* <Form.Item label="责任护士" name="belong_nurse_id" >
                    <Select virtual={false}>
                        {ep35Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="营养师" name="belong_dietician_id" >
                    <Select virtual={false}>
                        {ep36Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="产康师" name="belong_recover_id" >
                    <Select virtual={false}>
                        {ep37Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="护理师" name="belong_look_after_id" >
                    <Select virtual={false}>
                        {ep38Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item> */}
                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Space>
                        <Button type="primary" title='更换护士只需要选择护士' onClick={()=>{
                            baseAxiosComplete.post('/nursing/customer/detail/change_nurse', {
                                check_in_id:param.id,
                                belong_nurse_id: form.getFieldValue('belong_nurse_id'), // 责任护士id
                            }).then(res => {
                                if (res.status === 0){
                                    setVisible2(false)
                                    if(prop.onChange) prop.onChange()
                                }
                            })
                        }}>更换护士</Button>
                        <Button type="dashed" title='可提前下单并更换护理师' onClick={()=>{
                            baseAxiosComplete.post('/nursing/customer/detail/advance_place_order', {
                                check_in_id:param.id,
                                new_look_after_id:form.getFieldValue('new_look_after_id'),
                                advance_reason:form.getFieldValue('advance_reason'),
                                down_single_time:form.getFieldValue('down_single_time') ? form.getFieldValue('down_single_time').format('YYYY-MM-DD hh:mm:ss') : '',
                            }).then(res => {
                                if (res.status === 0){
                                    setVisible2(false)
                                    if(prop.onChange) prop.onChange()
                                }
                            })
                        }}>护理师提前下单</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>

        <div className="top clear">
            <h3 className="fl"><span className="fl">服务人员信息</span></h3>
            {hasServiceEmployee===0 && <div className="fr editbtn"  onClick={() => {
                if(prop.serviceData){
                    form.setFieldsValue({
                        belong_nurse_id: prop.serviceData.belong_nurse_id,
                        belong_look_after_id: prop.serviceData.belong_look_after_id
                    })
                }
                setVisible(true)
            }}><EditOutlined style={{marginRight:10}} />分配服务人员</div>}
            
            {hasServiceEmployee===1 && <div className="fr editbtn"  onClick={() => {
                if(prop.serviceData){
                    form.setFieldsValue({
                        belong_nurse_id: prop.serviceData.belong_nurse_id,
                        belong_look_after_id: prop.serviceData.belong_look_after_id
                    })
                }
                setVisible2(true)
            }}><EditOutlined style={{marginRight:10}} />更换服务人员</div>}
        </div>
        <div style={{marginTop:20}}>
            <Row style={{width:'100%'}}>
                <Col span={8}>
                    <div>
                        <Space>
                            <p className="label" style={{minWidth:90,textAlign:'right'}}>责任管家：</p>
                            <p className='right-text-waiters'>{ prop.serviceData && prop.serviceData.belong_minion_name ? prop.serviceData.belong_minion_name : '--'} </p>
                        </Space>
                    </div>
                </Col>
                <Col span={8}>
                    <div>
                        <Space>
                            <p className="label" style={{minWidth:90,textAlign:'right'}}>生活助理：</p>
                            <p className='right-text-waiters'>{ prop.serviceData && prop.serviceData.belong_cleaner_name ? prop.serviceData.belong_cleaner_name : '--'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={8}>
                    <div>
                        <Space>
                            <p className="label" style={{minWidth:90,textAlign:'right'}}>责任护士：</p>
                            <p className='right-text-waiters'>{ prop.serviceData && prop.serviceData.belong_nurse_name ? prop.serviceData.belong_nurse_name : '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
            <Row style={{width:'100%'}}>
                <Col span={8}>
                    <div>
                        <Space>
                            <p className="label" style={{minWidth:90,textAlign:'right'}}>营养师：</p>
                            <p className='right-text-waiters'>{ prop.serviceData && prop.serviceData.belong_dietician_name  ? prop.serviceData.belong_dietician_name : '--'}</p>
                        </Space>
                    </div>
                </Col><Col span={8}>
                    <div>
                        <Space>
                            <p className="label" style={{minWidth:90,textAlign:'right'}}>产康师：</p>
                            <p className='right-text-waiters'>{ prop.serviceData && prop.serviceData.belong_recover_name  ? prop.serviceData.belong_recover_name : '--'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={8}>
                    <div>
                        <Space>
                            <p className="label" style={{minWidth:90,textAlign:'right'}}>一对一护理师：</p>
                            <p className='right-text-waiters'>{ prop.serviceData && prop.serviceData.belong_look_after_name  ? prop.serviceData.belong_look_after_name : '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    </div>)
}